module.exports = __webpack_public_path__ + "img/logo.221e8499.svg";